import { Controller } from "@hotwired/stimulus"

// No jQuery needed - just calls global vendor functions
export default class extends Controller {
  connect() {
    // These functions are defined in app/frontend/vendor/
    // They handle arrow key navigation and toggle behavior for paper tests
    // (They use jQuery internally via noConflict, but we don't need it here)
    if (typeof arrow_key === 'function') {
      arrow_key()
    }
    if (typeof custom_toggle === 'function') {
      custom_toggle()
    }
  }
}
